<template>
    <view-section-card v-bind="{ ...$attrs, title, loading, actionCols }" hide-divider>
        <template #actions>
            <v-switch :input-value="value" v-bind="{ loading, color: switchColor }" dense inset hide-details class="my-0 ml-0 mr-n3 pa-0" @change="toggle" />
        </template>
        <v-expand-transition v-if="0 < Object.keys($slots).length">
            <v-sheet v-show="value">
                <v-divider />
                <v-card-text>
                    <slot />
                </v-card-text>
            </v-sheet>
        </v-expand-transition>
    </view-section-card>
</template>

<script>
import ViewSectionCard from "./view-section-card.vue";

export default {
    components: {
        ViewSectionCard,
    },
    props: {
        // mevn3 의 v-model:shows → Vue 2 v-model(value/input)
        value: { type: Boolean, default: false },

        title: { type: String },
        actionCols: { type: [String, Number], default: "auto" },

        loading: { type: Boolean, default: false },

        switchColor: { type: String, default: "primary" },
    },
    methods: {
        toggle(value) {
            this.$emit("input", !!value);
        },
    },
};
</script>

<style></style>
